import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-14738611")
const _hoisted_1 = { class: "justify-center mt-4 d-flex width-full" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "d-inline" }
const _hoisted_4 = ["value", "selected"]
const _hoisted_5 = { class: "d-inline" }
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = {
  key: 0,
  class: "d-inline"
}
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = { class: "d-inline" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("mdi-delete")
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["value", "selected"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["value", "selected"]
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("mdi-plus")
_popScopeId()

import { withDefaults, computed, reactive, ref } from 'vue'
import Action from '@/components/Dialog/enums/DialogAction'
import TheDialog from '@/components/Dialog/TheDialog.vue'
import { IConditionGroup, IConditionField } from '@/interfaces/hoppermation'
import ConditionOperator from '@/lib/enums/ConditionOperator'
import { readableConditionOperators, readableConditionScopes, readableNumberOperators } from '@/lib/helper'
import ConditionScope from '@/lib/enums/ConditionScope'
import NumberOperator from '@/lib/enums/NumberOperator'

interface IProps {
  editCondition?: (data: IConditionGroup) => void
  conditionFields: IConditionField[]
  condition: IConditionGroup
}


export default /*#__PURE__*/_defineComponent({
  props: {
    editCondition: { type: Function, required: false, default: () => ({}) },
    conditionFields: { type: Array, required: true, default: () => [] },
    condition: { type: null, required: true, default: () =>
    ({
      operator: ConditionOperator.AND,
      countOperator: NumberOperator.GTE,
      count: 1,
      scope: ConditionScope.CONTACT,
      conditions: [{}]
    } as IConditionGroup) }
  },
  setup(__props: any) {

const props = __props as { editCondition: (data: IConditionGroup) => void, conditionFields: IConditionField[], condition: IConditionGroup }


const {
  operator: initialOperator,
  scope: initialScope,
  countOperator: initialCountOperator,
  count: initialCount
} = { ...props.condition }
let operator = ref(initialOperator)
let countOperator = ref(initialCountOperator)
let count = ref(initialCount)
let scope = ref(initialScope)

const tempConditions = reactive([...props.condition.conditions])

const operators = computed((): ConditionOperator[] => {
  return [ConditionOperator.AND, ConditionOperator.OR]
})

const scopes = computed((): ConditionScope[] => {
  return Object.values(ConditionScope)
})

const numberOperators = computed((): NumberOperator[] => {
  return Object.values(NumberOperator)
})

const fields = computed((): { field: string; fieldLabel: string }[] => {
  return props.conditionFields
    .filter((field) => field.scope === scope.value)
    .map(({ field, fieldLabel }) => ({ field, fieldLabel }))
})

const fieldOperators = (field: string): ConditionOperator[] => {
  return props.conditionFields.find((item) => item.field === field)?.operators || []
}

const action = Action.CONFIRM

const addCondition = () => {
  tempConditions.push({})
}

const deleteCondition = (index: number) => {
  tempConditions.splice(index, 1)
}

const onSubmit = (): boolean => {
  props.editCondition({
    operator: operator.value,
    scope: scope.value,
    count: count.value,
    countOperator: countOperator.value,
    conditions: tempConditions,
    conditionGroups: []
  })
  return true
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(TheDialog, {
    action: _unref(action),
    title: _ctx.$t('dialog.condition.title'),
    submit: onSubmit,
    width: 1000,
    imageSrc: "https://assets4.lottiefiles.com/packages/lf20_qh75a3am.json"
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, _mergeProps(props, {
          color: "primary",
          class: "dialog-actions",
          text: ""
        }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('dialog.condition.title')), 1)
          ]),
          _: 2
        }, 1040)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "mb-4 text-subtitle",
        innerHTML: _ctx.$t('dialog.condition.desc')
      }, null, 8, _hoisted_2),
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "flex-row flex-row-reverse px-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('dialog.condition.form.1')), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "px-2 mx-2 select d-inline",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(operator) ? operator.value = $event : operator = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            value: item,
                            selected: item === _unref(operator)
                          }, _toDisplayString(_ctx.$t(_unref(readableConditionOperators)(item))), 9, _hoisted_4))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(operator)]
                      ]),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('dialog.condition.form.2')), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "px-2 mx-2 select d-inline",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(scope) ? scope.value = $event : scope = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scopes), (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            value: item,
                            selected: item === _unref(scope)
                          }, _toDisplayString(_ctx.$t(_unref(readableConditionScopes)(item))), 9, _hoisted_6))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(scope)]
                      ]),
                      (_unref(scope) !== _unref(ConditionScope).CONTACT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("select", {
                              class: "px-2 mx-2 select d-inline",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(countOperator) ? countOperator.value = $event : countOperator = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numberOperators), (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: item,
                                  value: item,
                                  selected: item === _unref(countOperator)
                                }, _toDisplayString(_ctx.$t(_unref(readableNumberOperators)(item))), 9, _hoisted_8))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _unref(countOperator)]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "mx-2 number-field d-inline",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(count) ? count.value = $event : count = $event))
                            }, null, 512), [
                              [_vModelText, _unref(count)]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('dialog.condition.form.3')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "flex-row flex-row-reverse px-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tempConditions), (conditionItem, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: conditionItem,
                              value: conditionItem
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "button",
                                  onClick: () => deleteCondition(index)
                                }, [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_10),
                                _withDirectives(_createElementVNode("select", {
                                  class: "px-2 mx-2 select d-inline",
                                  "onUpdate:modelValue": ($event: any) => (conditionItem.field = $event)
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), ({ field, fieldLabel }) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: field,
                                      value: field,
                                      selected: field === conditionItem.field
                                    }, _toDisplayString(fieldLabel), 9, _hoisted_13))
                                  }), 128))
                                ], 8, _hoisted_12), [
                                  [_vModelSelect, conditionItem.field]
                                ]),
                                (conditionItem.field)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      class: "px-2 mx-2 select d-inline",
                                      "onUpdate:modelValue": ($event: any) => (conditionItem.operator = $event)
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldOperators(conditionItem.field), (operator) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: operator,
                                          value: operator,
                                          selected: operator === conditionItem.operator
                                        }, _toDisplayString(_ctx.$t(_unref(readableConditionOperators)(operator))), 9, _hoisted_15))
                                      }), 128))
                                    ], 8, _hoisted_14)), [
                                      [_vModelSelect, conditionItem.operator]
                                    ])
                                  : _createCommentVNode("", true),
                                (conditionItem.operator)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "text",
                                      class: "mx-2 text-field",
                                      "onUpdate:modelValue": ($event: any) => (conditionItem.value = $event)
                                    }, null, 8, _hoisted_16)), [
                                      [_vModelText, conditionItem.value]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128)),
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "button",
                                onClick: addCondition
                              }, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["action", "title"]))
}
}

})